<template>
  <v-container>
    <v-flex xs12>
      <v-layout align-start justify-center px-5 pb-5 wrap>
        <edit-chapter :chapter="chapter"></edit-chapter>
        <content-list :chapter="chapter" class="mt-3" />
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import {
  getChapterByID,
} from "@/firebase/api/chapter";
import ContentList from "./contentList";
import EditChapter from './editChapter'

export default {
  components: {
    ContentList,
    EditChapter
  },

  data: () => ({
    chapter: {},
  }),

  mounted() {
    this.$bind("chapter", getChapterByID(this.$route.params.chapterID));
  }
};
</script>